import React, { useEffect, useState } from 'react';
import ImageCards from './Cards/ImageCards';
import TextCards from './Cards/TextCards';
import PodCasts from './Cards/PodCasts';
import JobPostings from './Cards/JobPostings';
import { Carousel } from 'react-responsive-carousel';
import Slider from 'react-slick';
import {
	BackwardWelCarousel,
	ForwardWelCarousel,

} from '../../../Components/FeatureComponents/Buttons/IconButton/Icons';
const ProductSelectionCard = (props: any) => {
	const [imageCards, setImageCards] = useState([]);
	const [videoCards, setVideoCards] = useState([]);
	const [podCast, setPodCast] = useState([]);
	const [textCards, setTextCards] = useState([]);
	const [jobPostings, setJobPostings] = useState([]);
	const[mobile,setMobile]=useState(false)
	useEffect(() => {
		if (
			window.innerWidth < 800 ||
			window.screen.width < 800
		) {
			setMobile(true)
		}
		else{
			setMobile(false)
		}
		window.addEventListener('resize', function(event) {
			
			if (
				window.innerWidth < 800 ||
				window.screen.width < 800
			) {
				setMobile(true)
			}
			else{
				setMobile(false)
			}
		})
		if (props.productData) {

			setImageCards(props.productData.lists.items);

			setTimeout(() => {
				const chatbodyWrapper = document.querySelector('.sf-chatbody');
				chatbodyWrapper.scrollTo({ top: chatbodyWrapper.scrollHeight });
			}, 100);
		}
	}, []);

	const slider = React.useRef<any>();
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToScroll: 1,
		slidesToShow: 3,
		prevArrow: (
			<div
				className='ff-back-wel'
				onClick={() => {
					previous();
				}}
			>
				<BackwardWelCarousel
					className='ff-back-wel'
					width='31px'
					height='31px'
					filledColor={props.selectedColor}
					fill={
						props.colorMode === 'dark'
							? '#fff'
							: props.colorScale && props.colorScale[0]
					}
				/>
			</div>
		),
		nextArrow: (
			<div
				onClick={() => {
					next();
				}}
			>
				<ForwardWelCarousel
					className='ff-next-wel'
					width='24px'
					height='24px'
					filledColor={props.selectedColor}
					fill={
						props.colorMode === 'dark'
							? '#fff'
							: props.colorScale && props.colorScale[0]
					}
				/>
			</div>
		),
	};
	const next = () => {
		console.log('Next');
		slider.current.slickNext();
	};
	const previous = () => {
		console.log('Prev');
		slider.current.slickPrev();
	};
	return (
		<>
			<div
				className='ff-chatbot-product-display-fullscreen'
				style={{
					display: 'flex',
					flexDirection: 'column',
					marginLeft: '16px',
					paddingBottom: '30px',
				}}
			>
				<div className='ff-leads-parent'>
					{imageCards && imageCards.length !== 0 && (
						<div
							style={{
								margin: '0px 0',
							}}
							dangerouslySetInnerHTML={{ __html: props.productData.displayResponse }}
						// dangerouslySetInnerHTML={__html: props.productData.displayResponse

						// }
						>

						</div>
					)}
					<div style={{ display: "flex", justifyContent: 'end' }}>
						{props.productData.quicklinks.items.map((item) => {
							return (
								<div className='ff-leads-btn' onClick={() => { props.handleSubmit(item.actionText) }}>{item.actionText}</div>
							)
						})

						}
					</div>
				</div>
				<div style={{ display: 'flex', gap: '20px', marginTop: '15px' }}>
					{imageCards && imageCards.length <= 3 && !mobile
						? imageCards.map((product) => (
							<>
								<ImageCards
									readMoreUrl={() => { props.handleSubmit(product.resourceURL.actionText) }}
									heading={product.resourceURL.title}
									desc={""}
									URL={product.resourceURL.url}
									displayCardCount={imageCards.length}
								/>
							</>
						))
						: imageCards && imageCards.length > 3 && !mobile?
							<div style={{ display: 'flex', justifyContent: 'center' }}>
								<div className='ff-product-carousel'
									style={{ maxWidth: '70.6vw' }}
								>

									<Slider {...settings}>
										{
											imageCards.map((product) => (
												<>
													<ImageCards
														readMoreUrl={() => { props.handleSubmit(product.resourceURL.actionText) }}
														heading={product.resourceURL.title}
														desc={""}
														URL={product.resourceURL.url}
														displayCardCount={imageCards.length}
													/>
												</>
											))
										}

									</Slider>
								</div>
								{/* <Carousel>
									

								</Carousel> */}
							</div>
							:
							<div>
							<div className='ff-product-carousel'
								>

							<Carousel
							showArrows={true}
							showStatus={false}
							showThumbs={false}
							showIndicators={true}
							centerMode
							centerSlidePercentage={
								(window.innerWidth < 800 && window.innerWidth > 450) ||
								(window.screen.width < 800 && window.screen.width > 450)
									? 50
									: 80
							}
							width={'100%'}
							renderArrowNext={(onClickHandler, hasNext) =>
								hasNext && (
									<button
										className={`carouselButtons clickable right `}
										onClick={onClickHandler}
										style={{
											top: '90px',
											right:'4px'
										}}
									>
										{/* <ArrowRight /> */}
										<ForwardWelCarousel 
										filledColor={props.selectedColor}
										fill={
											props.colorMode === 'dark'
												? 'var(--selectedColor)'
												: props.colorScale && props.colorScale[0]
										}
										
										/>
									</button>
								)
							}
							renderArrowPrev={(onClickHandler, hasPrev) =>
								hasPrev && (
									<button
										className={`carouselButtons clickable left `}
										onClick={onClickHandler}
										
										style={{
											top: '90px',
											left:'20px',
										}}
									
									>
										{/* <ArrowLeft /> */}
										<BackwardWelCarousel 
										filledColor={props.selectedColor}
										fill={
											props.colorMode === 'dark'
												? 'var(--selectedColor)'
												: props.colorScale && props.colorScale[0]
										}
										/>
									</button>
								)
							}
					>
							{
											imageCards.map((product) => (
												<>
													<ImageCards
														readMoreUrl={() => { props.handleSubmit(product.resourceURL.actionText) }}
														heading={product.resourceURL.title}
														desc={""}
														URL={product.resourceURL.url}
														displayCardCount={imageCards.length}
													/>
												</>
											))
										}

						</Carousel>
 </div>
 </div>
					}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{videoCards && videoCards.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								textTransform: 'uppercase',
								fontWeight: 'bold',
							}}
						>
							{videoCards[0].heading}
						</div>
					)}
					{videoCards && videoCards.length
						? videoCards.map((product, i) => (
							<>
								<ImageCards
									readMoreUrl={product.redirectLink}
									heading={product.title}
									desc={product.reasonQuery}
									URL={product.resourceURL.url}
									type='video'
									displayCardCount={videoCards.length}
								/>
							</>
						))
						: null}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{textCards && textCards.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								textTransform: 'uppercase',
								fontWeight: 'bold',
							}}
						>
							{textCards[0].heading}
						</div>
					)}
					{textCards && textCards.length
						? textCards.map((product, i) => (
							<>
								<TextCards
									text={product.title}
									index={i}
									handleSubmit={props.handleSubmit}
									type={product.imageURL ? 'sources' : ''}
									redirectURL={product.imageURL}
								/>
							</>
						))
						: null}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{podCast && podCast.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								textTransform: 'uppercase',
								fontWeight: 'bold',
							}}
						>
							{podCast[0].heading}
						</div>
					)}
					{podCast && podCast.length
						? podCast.map((product, i) => (
							<>
								{' '}
								{i === 0 ? (
									<PodCasts
										heading={product.title}
										url={product.imageURL}
										desc={product.title}
										redirectURL={product.redirectLink}
									/>
								) : null}
							</>
						))
						: null}
				</div>
				<div style={{ display: 'flex', gap: '20px' }}>
					{jobPostings && jobPostings.length !== 0 && (
						<div
							style={{
								margin: '20px 0',
								textTransform: 'uppercase',
								fontWeight: 'bold',
							}}
						>
							{jobPostings[0].heading}
						</div>
					)}
					{jobPostings && jobPostings.length
						? jobPostings.map((product, i) => (
							<>
								<JobPostings
									heading={product.title}
									redirectURL={product.imageURL}
									index={i}
									jobReqId='SR-11234'
									postingDate='1 week ago'
									location='Mumbai'
									timeType='Full time'
								/>
							</>
						))
						: null}
				</div>
			</div>
		</>
	);
};

export default ProductSelectionCard;
